<template>
  <div class="exact-live-panel" :style="{ backgroundImage: 'url(' + referenceAsset('home-final', 'bg17') + ')' }">
    <nav class="exact-live-tabs" aria-label="赛事类型">
      <button v-for="tab in liveTabs" :key="tab" :class="{ active: liveTab === tab }" @click="liveTab = tab">{{ tab }}</button>
      <select v-model="matchType" aria-label="赛事筛选"><option>所有赛事</option><option v-for="name in eventNames" :key="name">{{ name }}</option></select>
    </nav>
    <div class="exact-match-strip">
      <button v-for="match in visibleSchedule" :key="match.id" :aria-pressed="selectedMatch?.id === match.id" @click="selectMatch(match)"><small>{{ match.time }}</small><b>{{ match.home }} <i>VS</i> {{ match.away }}</b><span>查看赛事</span></button>
      <div v-if="!isLoggedIn" class="live-login"><p>登录后查看赛事动态</p><button type="button" @click="openAuth('login')">立即登录</button></div><p v-else-if="!visibleSchedule.length">暂无赛事直播</p>
    </div>
    <div class="exact-live-content">
      <div>
        <header>{{ selectedMatch ? selectedMatch.home + ' VS ' + selectedMatch.away : '万博体育　官方宣传' }}</header>
        <div class="exact-live-screen" :style="{ backgroundImage: 'url(' + referenceAsset('home-final', 'bg19') + ')' }"><button @click="navigate('/game/sport')" aria-label="查看体育场馆">▶</button></div>
        <button class="exact-live-more" @click="navigate('/game/sport')">更多比赛 ›</button>
      </div>
      <aside aria-live="polite">
        <h3>赛事动态</h3>
        <ErrorNotice v-if="liveEventsError" :message="liveEventsError"><button @click="loadMemberExtras">重新加载</button></ErrorNotice>
        <p v-else-if="detailLoading" role="status">正在获取赛事详情…</p>
        <ErrorNotice v-else-if="detailError" :message="detailError"><button @click="selectMatch(selectedMatch)">重试</button></ErrorNotice>
        <template v-else-if="selectedMatch"><p>{{ selectedMatch.eventName }}</p><p>{{ selectedMatch.home }} VS {{ selectedMatch.away }}</p><p>{{ matchStart }}</p><p v-if="selectedMatch.eventCode">赛事编号：{{ selectedMatch.eventCode }}</p></template>
        <p v-else>暂无赛事消息</p>
      </aside>
    </div>
  </div>
</template>
<script setup>
import ErrorNotice from './feedback/ErrorNotice.vue'
import { computed, onBeforeUnmount, ref, watch } from 'vue'
import { useAppContext } from '../composables/appContext'
import { referenceAsset } from '../config/referencePresentation.js'
import { webApi } from '../services/webApi'
import { authStorage } from '../services/http'

const { displaySchedule, isLoggedIn, openAuth, liveEventsError, loadMemberExtras, navigate } = useAppContext()
const liveTabs = ['万博主播', '足球赛事', '篮球赛事', '电竞赛事']
const liveTab = ref('足球赛事'), matchType = ref('所有赛事'), selectedMatch = ref(null)
const detailLoading = ref(false), detailError = ref('')
let detailVersion = 0
const eventNames = computed(() => [...new Set((isLoggedIn.value ? displaySchedule.value : []).map(event => event.eventName).filter(Boolean))])
const visibleSchedule = computed(() => {
  if (!isLoggedIn.value) return []
  return displaySchedule.value.filter(event => {
    const basketball = /篮球|NBA|CBA|WNBA/i.test(event.eventName || '')
    const category = liveTab.value === '万博主播' ? Number(event.hasAnchor) === 1 : liveTab.value === '电竞赛事' ? Number(event.eventType) === 2 : liveTab.value === '篮球赛事' ? Number(event.eventType) === 1 && basketball : Number(event.eventType) === 1 && !basketball
    return category && (matchType.value === '所有赛事' || event.eventName === matchType.value)
  }).slice(0, 12)
})
const matchStart = computed(() => selectedMatch.value?.matchStartAt ? new Date(selectedMatch.value.matchStartAt * 1000).toLocaleString('zh-CN', { hour12: false }) : '开赛时间待定')

async function selectMatch(match) {
  const ticket = ++detailVersion, token = authStorage.getToken()
  selectedMatch.value = null
  detailLoading.value = false
  detailError.value = ''
  if (!match?.id || !isLoggedIn.value || !token) return
  selectedMatch.value = match
  detailLoading.value = true
  try {
    const detail = await webApi.liveEventDetail(match.id)
    if (ticket !== detailVersion || token !== authStorage.getToken() || !isLoggedIn.value) return
    if (!detail || String(detail.id) !== String(match.id)) throw new Error('赛事详情获取失败，请重试')
    selectedMatch.value = { ...detail, home: detail.homeTeamName || detail.eventName, away: detail.awayTeamName || '待定' }
  } catch (error) {
    if (ticket === detailVersion && token === authStorage.getToken() && isLoggedIn.value) detailError.value = error.message || '赛事详情获取失败'
  } finally {
    if (ticket === detailVersion) detailLoading.value = false
  }
}
watch(visibleSchedule, rows => {
  if (!rows.some(event => event.id === selectedMatch.value?.id)) void selectMatch(rows[0] || null)
}, { immediate: true })
onBeforeUnmount(() => { detailVersion++ })
</script>

<style scoped>
.live-login { display:flex; align-items:center; justify-content:center; flex-wrap:wrap; gap:8px 16px; width:100%; color:var(--kg-text-secondary,#65738b); font-size:14px; }
.live-login p { margin:0; }
.live-login button { min-height:44px; padding:8px 12px; border:0; background:transparent; color:var(--kg-brand,#179cff); font:inherit; cursor:pointer; }
.live-login button:focus-visible { outline:2px solid var(--kg-brand,#179cff); outline-offset:2px; }
</style>
